import { ListResponse, PostModel } from "common/models/baseModel";
import api from "utils/api";
import { endpoints } from "utils/endpoints";

import { createQueryKeys } from "@lukemorales/query-key-factory";
import { IDropdownModel } from "common/models/IDropdownModel";
import {
  ISpecialization,
  ISpecializationGridFilter,
  ISpecializationGridModel,
} from "./types";
import { specializationView } from "../types/specializationView";

export const specialization = createQueryKeys("specialization", {
  list: (postModel: PostModel<ISpecializationGridFilter>) => ({
    queryKey: [postModel],
    queryFn: () =>
      api.post<ListResponse<ISpecializationGridModel>>(
        endpoints.specialization.list,
        postModel
      ),
  }),
  get: (id: number) => ({
    queryKey: [id],
    queryFn: () =>
      api.get<ISpecialization>(`${endpoints.specialization.get}/${id}`),
  }),
  view: (id: number) => ({
    queryKey: [id],
    queryFn: () =>
      api.get<specializationView>(`${endpoints.specialization.view}/${id}`),
  }),
  getAllspecializationValues: {
    queryKey: null,
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.specialization.getAllspecializationValues}`
      ),
  },
  specializationValues: {
    queryKey: null,
    queryFn: () =>
      api.get<IDropdownModel[]>(
        `${endpoints.specialization.specializationValues}`
      ),
  },
});
